import { useMemo, useEffect, useState } from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import useCurrentUser from '../../hooks/useCurrentUser';

interface UseTrackPageOptions {
  pageContext: {
    track: {
      registrationDescriptionHtml?: string;
    };
    description?: string;
  };
}

export const useTrackPage = ({ pageContext }: UseTrackPageOptions) => {
  const { track } = pageContext;
  const [tokenParam, setTokenParam] = useQueryParam('token', StringParam);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const { currentUser, savePersistedToken } = useCurrentUser();

  const description = useMemo(() => {
    if (pageContext.description) return pageContext.description;
    return track.registrationDescriptionHtml;
  }, [pageContext.description, track.registrationDescriptionHtml]);

  useEffect(() => {
    if (tokenParam) {
      setTokenParam(undefined, 'replaceIn');
      savePersistedToken(tokenParam);
    }
  }, [tokenParam, setTokenParam, savePersistedToken]);

  return {
    description,
    termsAccepted,
    setTermsAccepted,
    currentUser,
  };
};
